import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import './Loader.css';
import { Backdrop } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
const Loader = (props) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Backdrop className={classes.backdrop} open={open} onClick={handleClose}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'row',
            margin: '0 auto',
            // justifyContent: 'center',
            // alignItems: 'center',
          }}
        >
          <span
            style={{ fontSize: '1.5rem', textAlign: 'center', fontWeight: 700 }}
          >
            Loading
          </span>

          <ul id='second' style={{ alignSelf: 'flex-end', marginTop: '15%' }}>
            <li></li>
            <li></li>
            <li></li>
          </ul>
        </div>
        <br />
        <ul id='first'>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </div>
    </Backdrop>
  );
};

Loader.propTypes = {};

export default Loader;
